<script lang='ts'>

    /* IMPORTS --------------------------------------------------------------------------------- */

    // CASSIOPEIA
    import { Link, Paragraph, Icon } from '@smatch/cassiopeia-web-components';

    // CONFIG
    import { PRIVACY_STATEMENT_URL, TERMS_URL } from 'src/config';


</script>

<div id = 's8-layout-landing'>
    <div class = 's8-wrap-main'>
        <main>
            <div class = 's8-wrap-icon'>
                <Icon key = 'smatch' />
            </div>
            <slot />
        </main>
        <section>
            <Paragraph css = 'mt-2' align = 'center'>
                By signing up you agree to smatch’s <Link label = 'Terms' url = { TERMS_URL } css = 'underline' />
                and <Link url = { PRIVACY_STATEMENT_URL } css = 'underline' label = 'Privacy Policy'/>.
            </Paragraph>
        </section>
    </div>
</div>

<style lang='postcss'>

    div#s8-layout-landing {
        position: absolute;
        top: 0px;
        left: 0px;
        right: 0px;
        bottom: 0px;
        display: flex;
        flex-direction: row;
        container-name: layout;
        container-type: inline-size;
        background-color: rgba(68, 131, 95, 1.00);
        background: radial-gradient(at center, rgba(68, 131, 96, 1.0), rgba(31, 71, 48, 1.0));

        div.s8-wrap-icon {
            border-radius: 120px;
            height: 80px;
            width: 80px;

            background: rgba(39,39,17,0.03);
            box-shadow: 0 1px 2px 0 rgba(39,39,17,0.4);

            margin-bottom: 20px;
            display: flex;
            justify-content: center;
            align-items: center;

            :global(svg) {
                height: 40px;
            }
        }

        div.s8-wrap-main {
            min-width: 380px;
            max-width: 1000px;
            margin: 60px auto;
            padding: 60px;
            flex: 1;
            display: flex;
            flex-direction: column;
            row-gap: 20px;
            overflow-y: auto;
            background-color: #ffffff;
            border-radius: 10px;

            main {
                flex-grow: 1;
                min-height: fit-content;
            }
        }
    }

    @media (max-width: 1020px) {
        div#s8-layout-landing {
            div.s8-wrap-main  {
                margin-left: 10px;
                margin-right: 10px;
            }
        }
    }

    @media (max-width: 780px) {
        div#s8-layout-landing {
            div.s8-wrap-main  {
                margin: 10px;
                border-radius: 10px;
                padding: 20px;
                min-width: auto;
            }
        }
    }

</style>